import { shuffle } from './_lib/shuffle.js';

export const worksList = {
  duration: 15,
  observeOptions: {
    //ルートとしてviewportを設定
    root: null,
    //上下0px、左右0px手前で発火
    rootMargin: '0px 0px',
    // 交差領域が50%の時
    threshold: 1
  },
  init: ()=>{
    if(document.getElementById('main').classList.contains('work')){
      const targets = document.querySelectorAll('.work__list__li');
      const observer = new IntersectionObserver(callback, worksList.observeOptions);
      function callback(entries, observer){
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            const mosaic = shuffle(entry.target.querySelectorAll('path'));
            Array.prototype.slice.call(mosaic,0).forEach((elm, i) => {
              setTimeout(()=>{
                elm.classList.add('hide');
              }, i * worksList.duration);
            });
            observer.unobserve(entry.target);
          }
        });
      }
      targets.forEach((target) => {
        observer.observe(target);
      });
    }
  }
}
